import React from "react"
import PropTypes from "prop-types"

interface SpinnerProps {
  height?: number
  width?: number
  color?: string
  strokeWidth?: number
  className?: string
}

const Spinner = ({
  height,
  width,
  color,
  strokeWidth,
  className
}: SpinnerProps) => (
  <span className={className} data-testid="spinner">
    <svg
      height={height}
      width={width}
      viewBox="0 0 200 200"
      className="animate-spin"
    >
      <circle
        cx="100"
        cy="100"
        r="80"
        fill="none"
        stroke={color}
        strokeWidth={`${strokeWidth}px`}
        strokeDasharray="200px"
        strokeDashoffset="2000"
      />
    </svg>

    <span className="sr-only" role="alert" aria-busy="true">
      Loading...
    </span>
  </span>
)
Spinner.defaultProps = {
  height: 100,
  width: 100,
  color: `black`,
  strokeWidth: 5,
  className: `inline-block`
}

Spinner.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  strokeWidth: PropTypes.number,
  className: PropTypes.string
}

export default Spinner
